"use client";

import { useEffect } from "react";
import { useCookieConsent } from "@leabankab/component-library/cookie-consent/react";
import { useCountry } from "@/config/country-context";
import { useRuntimeConfig } from "@/config/runtime-config-context";
import { setGa4AnalyticsConsent } from "./ga4";

export const Ga4Init = () => {
	const { consent } = useCookieConsent();
	const { ga4MeasurementId } = useRuntimeConfig();
	const country = useCountry();
	const analyticsConsent = consent?.analytics;

	useEffect(() => {
		if (analyticsConsent === undefined) return;
		setGa4AnalyticsConsent({
			measurementId: ga4MeasurementId,
			granted: analyticsConsent,
			country,
		});
	}, [analyticsConsent, country, ga4MeasurementId]);

	return null;
};
